import http, { expandURI } from '@/utils/ajax'
import { JOURNAL_INIT_LOADING, JOURNAL_INIT_SUCCESS, JOURNAL_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  async journalInit({ commit, state }) {
    commit(JOURNAL_INIT_LOADING)
    const apiUrl = this.state.app.menu.journal
    const expand = {}
    if (apiUrl) {
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(JOURNAL_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(JOURNAL_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(JOURNAL_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  }
}
